import { Injectable, inject } from '@angular/core';

import { UserLoginEvent, UserLogoutEvent, UserService } from '@frontend/vanilla/core';
import { filter } from 'rxjs/operators';

import { IndexLoaderClientService } from '../content/index-loader.service';

@Injectable({ providedIn: 'root' })
export class SearchIndexLoaderRegistrationService {
    private readonly userService = inject(UserService);
    private readonly indexLoaderClientService = inject(IndexLoaderClientService);

    register(): void {
        this.userService.events.pipe(filter((e: any) => e instanceof (UserLoginEvent || UserLogoutEvent))).subscribe(() => {
            this.indexLoaderClientService.reloadIndex();
        });
    }
}
